import React, { Component } from 'react';
import PropTypes from 'prop-types';

import IconsBar from '../icons-bar/icons-bar';
import networksIconsData from '../../../services/networks-icons-data/networks-icons-data';

class NetworksIconsBar extends Component {        
  constructor(props) {
    super(props);

    this.state = {
      iconsData: networksIconsData.getIconsData(props.rawIconsData),
    };
  }

  render() {
    return (
      <IconsBar iconsData={this.state.iconsData} isCircles={this.props.isCircles} />
    );
  }
}

NetworksIconsBar.propTypes = {
  isCircles: PropTypes.bool,
  rawIconsData: PropTypes.object,
};

NetworksIconsBar.defaultProps = {
  isCircles: false
};

export default NetworksIconsBar;